import React from 'react';
import PropTypes from 'prop-types';
import * as search from 'searchtabular';
import PerPage from './PerPage';
import * as pluralize from "pluralize";
import { useState } from "react";
import GenModal from '../../Gen/Modal/component';
import { RenderStudentList } from '../aqueduct_table';
import ModalClose from 'app/assets/images/modal-close.svg'

const PrimaryControls = ({
  perPage, columns, rows, column, query,
  onPerPage, onSearch, onColumnChange,
  show_pagination, isCustomCoursePage, studentsCount, unknownEmails, selectedRows, toggleSelect, psaEmail, overAllSelected,
  showAdditionalQuestionsButton, additionalQuestionsButtonLabel, additionalQuestionsButtonId, additionalQuestionsButtonClassName,
  additionalQuestionsActionLabel, onAdditionalQuestionsAction, additionalQuestionsActionEvent,
  inlineActionLabel, onInlineAction, inlineActionButtonClassName,
  ...props
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const showAdditionalButton = showAdditionalQuestionsButton || additionalQuestionsActionLabel;
  const showInlineActionButton = !!inlineActionLabel;
  const showInlineButtons = showAdditionalButton || showInlineActionButton;
  const additionalButtonClass = additionalQuestionsButtonClassName || "aq-button-2 outline-whitebg";
  const inlineButtonClass = inlineActionButtonClassName || "aq-button-2 outline-whitebg";
  const handleAdditionalQuestionsClick = () => {
    if (onAdditionalQuestionsAction) {
      onAdditionalQuestionsAction();
      return;
    }
    if (additionalQuestionsActionEvent) {
      window.dispatchEvent(new CustomEvent(additionalQuestionsActionEvent));
    }
  };

  // Handler for "Close" button
  const handleClose = () => {
    setModalOpen(false);
  };

  // Handler for "Create Question" button
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  return (
    <div {...props}>
      {show_pagination &&
        <div className="per-page-container">
          <PerPage value={perPage} onChange={onPerPage}/>
        </div>
      }
      {isCustomCoursePage ?
        <>
          <div className="search-container">
            <search.Field
              column={column}
              query={query}
              columns={columns}
              rows={rows}
              onChange={onSearch}
              onColumnChange={onColumnChange}
              components={{
                filter: CustomField,
                props: {
                  filter: {
                    className: 'search-field',
                    placeholder: 'Search'
                  }
                }
              }}
            />
          </div>
          {studentsCount > 0 &&
            <>
              <div className="students-count">{pluralize('Student', studentsCount, true)}</div>
              <a className="students-count-mobile-view" onClick={handleModalOpen}>{pluralize('Student', studentsCount, true)}</a>

              <GenModal open={modalOpen}>
                <div className="gen-modal-panel">
                  <div className="gen-modal-header">
                    <div className="gen-modal-title">Student Added to Course</div>
                    <a onClick={handleClose} className="gen-modal-close">
                      <img src={ModalClose} alt="Close"/>
                    </a>
                  </div>
                  <div className="gen-modal-description">
                    These students were added by email but they are not yet rostered to your program. They can still be added to your course but will not have access until they have been rostered to your program and complete the registration process. 
                    <br/><br/>
                    Once they have been rostered and complete their registration, they will automatically be able to access this course.
                    <br/><br/>
                    For questions, contact {psaEmail}.
                  </div>
                  <div className="gen-modal-student-list">
                    <RenderStudentList
                      unknownEmails={unknownEmails}
                      rows={selectedRows}
                      toggleSelect={toggleSelect}
                      psaEmail={psaEmail}
                      overAllSelected={overAllSelected}
                    />
                  </div>
                </div>
              </GenModal>
            </>
          }
        </>
        :
        <div
          className="search-container"
          style={showInlineButtons ? { display: "flex", alignItems: "center", gap: "12px", minWidth: "500px" } : undefined}
        >
          <div
            style={showInlineButtons ? { marginBottom: "10px", flex: 1 } : undefined}
          >
            <span>Search</span>
            <search.Field
              column={column}
              query={query}
              columns={columns}
              rows={rows}
              onChange={onSearch}
              onColumnChange={onColumnChange}
            />
          </div>
          {showInlineActionButton && (
            <button
              type="button"
              className={inlineButtonClass}
              onClick={onInlineAction}
              style={{ fontSize: '10px', height: '42px' }}
            >
              {inlineActionLabel}
            </button>
          )}
          {showAdditionalButton && (
            <button
              type="button"
              id={additionalQuestionsButtonId}
              className={additionalButtonClass}
              onClick={handleAdditionalQuestionsClick}
            >
              {additionalQuestionsActionLabel || additionalQuestionsButtonLabel || "Add Additional Questions"}
            </button>
          )}
        </div>
      }
    </div>
  );
}

const CustomField = (props, classNames) => <input className={classNames.customField || "custom-field"} {...props} />;

PrimaryControls.propTypes = {
  perPage: PropTypes.number,
  columns: PropTypes.array,
  rows: PropTypes.array,
  column: PropTypes.string,
  query: PropTypes.object,
  onPerPage: PropTypes.func,
  onSearch: PropTypes.func,
  onColumnChange: PropTypes.func,
  isCustomCoursePage: PropTypes.bool,
  studentsCount: PropTypes.number,
  unknownEmails: PropTypes.array,
  selectedRows: PropTypes.array,
  toggleSelect: PropTypes.func,
  psaEmail: PropTypes.string,
  showAdditionalQuestionsButton: PropTypes.bool,
  additionalQuestionsButtonLabel: PropTypes.string,
  additionalQuestionsButtonId: PropTypes.string,
  additionalQuestionsButtonClassName: PropTypes.string,
  additionalQuestionsActionLabel: PropTypes.string,
  onAdditionalQuestionsAction: PropTypes.func,
  additionalQuestionsActionEvent: PropTypes.string,
  inlineActionLabel: PropTypes.string,
  onInlineAction: PropTypes.func,
  inlineActionButtonClassName: PropTypes.string
};

export default PrimaryControls;
